import organisationBookingTemplates from "./organisation-booking-templates";

export const ORGANISATION_BOOKING_TEMPLATES_NAMESPACE = `organisations/organisationBookingTemplates`;

export default organisationBookingTemplates;
